import { actions as snactions } from '../../snackbar'
import service from '../parent-api-service'
import types from '../types'
import fetchParents from './fetch'

const deleteParent = (parentId) => (dispatch) => {
  dispatch({
    type: types.DELETE_PARENTS_START,
  })
  return service
    .deleteParent(parentId)
    .then(() => {
      dispatch({ type: types.DELETE_PARENTS_SUCCESS })
    })
    .catch(() => {
      dispatch({ type: types.DELETE_PARENTS_FAILURE })
      dispatch(snactions.addSnackbarItem('An error occured when deleting a parent'))
    })
    .finally(() => {
      dispatch(fetchParents())
    })
}

export default deleteParent
